import { useOpsExtractionDashboard } from 'app/components/ops-extraction-dashboard/useOpsExtractionDashboard'
import { OpsExtractionDashboardShadcnComponent } from 'app/components/ops-extraction-dashboard/OpsExtractionDashboardShadcnComponent'

export let handle = {
  breadcrumb: `Extraction Dashboard`,
  title: `Extraction Dashboard`,
}

export default function ExtractionDashboard() {
  const hookData = useOpsExtractionDashboard()
  return <OpsExtractionDashboardShadcnComponent {...hookData} />
}
